module.exports = "//cdn.mxpnl.com/static/asset-cache/159b6a083f98df20540ef2c4f2b6cfca/iron/common/assets/images/charts/retention-trends.svg";